import {Text, useBreakpoint} from '@travel-frontend/core';
import {LabelMedium, Flex} from '@travel-frontend/ui-components';
import {useTranslation} from 'next-i18next';

import {Button} from '@/modules/hotels/components/List/components/UpliftAds/components/Banner/components/Inline/components/Button';
import {Container} from '@/modules/hotels/components/List/components/UpliftAds/components/Banner/components/Inline/components/Container';
import {Content} from '@/modules/hotels/components/List/components/UpliftAds/components/Banner/components/Inline/components/Content';
import {Headline} from '@/modules/hotels/components/List/components/UpliftAds/components/Banner/components/Inline/components/Headline';
import {Image} from '@/modules/hotels/components/List/components/UpliftAds/components/Banner/components/Inline/components/Image';
import {Logo} from '@/modules/hotels/components/List/components/UpliftAds/components/Banner/components/Inline/components/Logo';

type Props = {
  title: string;
  subtitle: string;
  image: string;
  logo?: string;
};
export const Inline: React.FunctionComponent<Props> = ({
  title,
  subtitle,
  image,
  logo,
}) => {
  const {t} = useTranslation('upliftAds');
  const isLargeScreen = useBreakpoint(['lg', 'xl']);
  return (
    <Flex maxHeight="930px" spacing="8px">
      <Text preset="labelMedium" color="contentSecondary">
        {t('label')}
      </Text>
      <Container spacing="0px" direction="row">
        <Image src={image} alt="" />
        <Content direction="column" justifyContent="center" spacing="16px">
          <Flex spacing="16px">
            <Flex spacing="4px">
              <Headline color="contentInversePrimary">{title}</Headline>

              {isLargeScreen && (
                <LabelMedium color="contentInversePrimary" truncate={1}>
                  {subtitle}
                </LabelMedium>
              )}
            </Flex>
            <Button variant="danger">{t('button')}</Button>
          </Flex>
        </Content>
        {logo && <Logo src={logo} alt="" />}
      </Container>
    </Flex>
  );
};
